/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Root_Team_LabelInputs */

const en_explorer_root_team_label = /** @type {(inputs: Explorer_Root_Team_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Drive`)
};

const fr_explorer_root_team_label = /** @type {(inputs: Explorer_Root_Team_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drive d'equipe`)
};

const de_explorer_root_team_label = /** @type {(inputs: Explorer_Root_Team_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Drive`)
};

const it_explorer_root_team_label = /** @type {(inputs: Explorer_Root_Team_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guida di squadra`)
};

const ru_explorer_root_team_label = /** @type {(inputs: Explorer_Root_Team_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Командное движение`)
};

const es_explorer_root_team_label = /** @type {(inputs: Explorer_Root_Team_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unidad de equipo`)
};

const zh_cn2_explorer_root_team_label = /** @type {(inputs: Explorer_Root_Team_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队驱动`)
};

const ja_explorer_root_team_label = /** @type {(inputs: Explorer_Root_Team_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームドライブ`)
};

const hi_explorer_root_team_label = /** @type {(inputs: Explorer_Root_Team_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम ड्राइव`)
};

const pt_pt2_explorer_root_team_label = /** @type {(inputs: Explorer_Root_Team_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipe Drive`)
};

/**
* | output |
* | --- |
* | "Team Drive" |
*
* @param {Explorer_Root_Team_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_root_team_label = /** @type {((inputs?: Explorer_Root_Team_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Root_Team_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_root_team_label(inputs)
	if (locale === "de") return de_explorer_root_team_label(inputs)
	if (locale === "it") return it_explorer_root_team_label(inputs)
	if (locale === "ru") return ru_explorer_root_team_label(inputs)
	if (locale === "es") return es_explorer_root_team_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_root_team_label(inputs)
	if (locale === "ja") return ja_explorer_root_team_label(inputs)
	if (locale === "hi") return hi_explorer_root_team_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_root_team_label(inputs)
	return en_explorer_root_team_label(inputs)
});